







































































































































import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/header/Header.vue'; // @ is an alias to /src
import Toolbar from '@/components/toolbar/Toolbar.vue';
import Footer from '@/components/footer/Footer.vue';
import QQSideBar from '@/components/qq-side-bar/QQ-side-bar.vue';
import imgs from '@/util/imgs.ts';

@Component({
  components: {
    Header,
    Toolbar,
    Footer,
    QQSideBar,
  },
})
export default class App extends Vue {
  // initial data
  private imgs = imgs;
  private showlogo = false;

  private toolbarItems = [
    { name: '贴合技术', active: '1' },
    { name: '缝制技术', active: '2' },
  ];
  private toolbarActive = '1';

  // 客服的qq号
  // 客服的qq号需要启用“QQ在线状态”服务才能临时聊天
  private qqAccounts = ['410465535', '32495306', '398992596'];
  // 是否自动找上次聊过的客服， true表示找上次的，false表示随机选客服
  private findLastCustomerService = false;

  private showing = false;

  // lifecycle hook
  private mounted() {
    const self = this;

    function loadingAddNum(num: number, step: number) {
      setTimeout(() => {
        const processbar: any = document.getElementById('processbar');
        const loadingratio: any = document.getElementById('loadingratio');
        processbar.style.width = num + '%';
        loadingratio.innerText = num + '%';

        if (num < 99) {
          let startNum = Math.ceil(num + step);
          if (startNum > 100) {
            startNum = 100;
          }
          loadingAddNum(startNum, step);
        } else {
          const homeloading: any = document.getElementById('homeloading');
          homeloading.classList.add('loaded');
          self.showlogo = true;
        }
      }, 100);
    }

    this.$nextTick(() => {
      const loadingratio: any = document.getElementById('loadingratio');
      loadingratio.classList.add('loaded');
      const startNum = Number(loadingratio.innerText.replace('%', '')) + 1;
      const step = (100 - startNum) / 10;

      loadingAddNum(startNum, step);
    });
  }

  get lang() {
    return this.$store.state.lang;
  }

  /**
   * 获取在线客服侧边栏的状态
   */
  get isCustomBarAvctive() {
    return this.$store.state.onlineCustomActive;
  }

  private handleMenuShowOrHide() {
    this.showing = !this.showing;
  }

  private changeLang() {
    this.showing = !this.showing;

    let command = 'en';

    if (this.$store.state.lang === 'en') {
      command = 'zh-CN';
    }

    this.$store.dispatch('setLang', command);
    this.$i18n.locale = command;
  }
}
